import { useState, useEffect } from 'react';
import { useParams  } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Filter, ChevronDown } from 'lucide-react';
import ProductCard from '../components/Ui/ProductCard';

import { useNavigate } from 'react-router-dom';
import { getSeasonProducts, getNewProducts, getTopViewedProducts } from '../services/categoryService';

const SeasonProductsPage = () => {
  const navigate = useNavigate();
  const { categoryId, subcategoryId } = useParams();
  const [filteredProducts, setFilteredProducts] = useState([]); 
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [sortBy, setSortBy] = useState('featured');
  const [products, setProducts] = useState([]);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('season');
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchProducts('season');
  }, []);


  const fetchProducts = async (type) => {
    setActiveTab(type);
    try {
      let data;
      if (type === 'season') {
        data = await getSeasonProducts();
      } else if (type === 'new') {
        data = await getNewProducts();
      } else if (type === 'viewed') {
        data = await getTopViewedProducts();
      }
      setProducts(data);
    } catch (error) {
      console.error('Ürünler alınırken hata:', error);
    }
  };



  useEffect(() => {
    let filtered = [...products];
  
    if (selectedCategory) {
      filtered = filtered.filter(product => product.category === selectedCategory);
    }
  
    switch (sortBy) {
      case 'price-asc':
        filtered.sort((a, b) => a.price - b.price);
        break;
      case 'price-desc':
        filtered.sort((a, b) => b.price - a.price);
        break;
      case 'name-asc':
        filtered.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 'name-desc':
        filtered.sort((a, b) => b.name.localeCompare(a.name));
        break;
      default:
        break;
    }
  
    setFilteredProducts(filtered);
  }, [selectedCategory, sortBy, products]);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };


  const handleSortChange = (e) => {
    setSortBy(e.target.value);
  };

  const toggleFilters = () => {
    setFiltersOpen(!filtersOpen);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-secondary-light py-12"
    >
      <div className="container-custom">
        <h1 className="text-3xl font-bold text-gray-dark mb-8">Ürünlerimiz</h1>

        <div className="lg:flex gap-8">
          <div className="lg:hidden mb-4">
            <button 
              onClick={toggleFilters}
              className="flex items-center justify-between w-full bg-white p-4 rounded-md shadow-soft"
            >
              <span className="flex items-center">
                <Filter size={18} className="mr-2" />
                Filtreler
              </span>
              <ChevronDown 
                size={18} 
                className={`transition-transform ${filtersOpen ? 'transform rotate-180' : ''}`} 
              />
            </button>
          </div>

          <aside className={`lg:block lg:w-1/4 ${filtersOpen ? 'block' : 'hidden'} mb-6 lg:mb-0`}>
      <div className="bg-white p-6 rounded-md shadow-soft">
        <h2 className="font-semibold text-lg mb-4 uppercase">Filtreler</h2>
        <ul className="space-y-2">

        <ul className="space-y-1 pl-6">
  {[
    { id: 'season', name: 'Sezon Ürünleri' },
    { id: 'new', name: 'Yeni Ürünler' },
    { id: 'viewed', name: 'Çok Görüntülenenler' },
  ].map((item) => (
    <li key={item.id}>
      <button 
        onClick={() => fetchProducts(item.id)}
        className={`text-left w-full capitalize py-1 ${
          activeTab === item.id ? 'text-primary font-medium' : 'text-gray-dark'
        }`}
      >
        {item.name}
      </button>
    </li>
  ))}
</ul>

        </ul>
      </div>
    </aside>




          <div className="lg:w-3/4">
            <div className="bg-white p-4 rounded-md shadow-soft mb-6 flex justify-between items-center">
              <div>
                <span className="text-gray-dark">
                  {filteredProducts.length} ürün bulundu
                </span>
              </div>
              <div>
                <select 
                  value={sortBy}
                  onChange={handleSortChange}
                  className="p-2 border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-primary"
                >
                  <option value="featured">Öne Çıkanlar</option>
                  <option value="price-asc">Fiyat: Düşükten Yükseğe</option>
                  <option value="price-desc">Fiyat: Yüksekten Düşüğe</option>
                  <option value="name-asc">İsim: A-Z</option>
                  <option value="name-desc">İsim: Z-A</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredProducts.length > 0 ? (
                filteredProducts.map(product => (
                  <ProductCard key={product.id} product={product} />
                ))
              ) : (
                <div className="col-span-full text-center py-12">
                  <p className="text-gray-dark text-lg">Ürün bulunamadı.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default SeasonProductsPage;
